<script setup>
definePage({ meta: { ...PageMeta.Quotes.Preview.Meta, pageTitle: 'Quote' } })

import { useRoute } from 'vue-router'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { useQuoteStore } from '@/@vxapp/Quotes/useQuoteStore'
import { useQuoteFieldRead } from '@/views/Previews/Quotes/useQuoteFieldRead'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import QuotesServicePage from '@/views/Previews/Quotes/QuotesServicePage.vue'
import QuotesVerticalSidebar from '@/views/Previews/Quotes/QuotesVerticalSidebar.vue'

const route = useRoute()
const quotesStore = useQuoteStore()

const currentQuote = () =>
  quotesStore.quote?.quoteGUID === route.params.guid ? quotesStore.quote : null

const canReadQuoteField = useQuoteFieldRead(
  currentQuote,
  () => false,
  () => Subject.QUOTES_PREVIEW_GUID
)

useEntityPageTitle({
  entityName: 'Quote',
  record: () => quotesStore.quote,
  recordGuid: quote => quote.quoteGUID,
  identifier: quote => (canReadQuoteField('id') ? quote.id : null),
})

/* ****** */
</script>

<template>
  <section>
    <VRow>
      <VCol
        cols="12"
        md="9"
      >
        <!-- QuotePreview -->
        <QuotesServicePage :key="route.params.guid" />
      </VCol>

      <VCol
        cols="12"
        md="3"
      >
        <!-- Sidebar -->
        <QuotesVerticalSidebar />
      </VCol>
    </VRow>
  </section>
</template>

<style lang="scss">
.quote-preview-table {
  --v-table-row-height: 44px !important;
}

@media print {
  .v-application {
    background: none !important;
  }

  @page {
    margin: 0;
    size: auto;
  }

  .layout-page-content,
  .v-row,
  .v-col-md-9 {
    padding: 0;
    margin: 0;
  }

  .product-buy-now {
    display: none;
  }

  .v-navigation-drawer,
  .layout-vertical-nav,
  .app-customizer-toggler,
  .layout-footer,
  .layout-navbar,
  .layout-navbar-and-nav-container {
    display: none;
  }

  .v-card {
    box-shadow: none !important;

    .print-row {
      flex-direction: row !important;
    }
  }

  .layout-content-wrapper {
    padding-inline-start: 0 !important;
  }
}
</style>
